/*
 * Get-town.ts
 * Description: Includes function for sending a request
  * to get the municipality and the province of a town
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Getting the municipality and the province of a town
 *
 * @param {String} ekatte - ekatte town number
 * @return {Object} Promise - municipality and province
 */
export function getTown(ekatte: string) {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url: APIURL + 'towns/' + ekatte,
            method: 'get',
        }).then((response) => {
            const data = response.data.data.attributes;
            resolve({
                municipality: data.town_hall.slice(0, 5),
                province: data.town_hall.slice(0, 3),
            });
        }).catch(() => {
            reject();
        });
    });
}
